export default {
  'seek assistance title':
    'How do I seek for assistance on questions or issues that I encounter?',
  'seek assistance content':
    'You can contact our team directly on our Discord server {action}',
  'seek assistance link': 'discord.gg/injective'
}
